<template>
  <div class="cp-article-list-view">
    <div
      class="cp-article-list-view-header-image"
      :style="{
        backgroundImage: `url('https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final-44_T8vQlK2x7.png')`,
      }"
    />
    <!-- <div class="cp-article-list-view-breadcrumbs-container">
      <Breadcrumbs />
    </div> -->

    <br />

    <div class="has-text-weight-bold has-text-primary is-size-4 has-text-centered">
     Blog
    </div>

    <br />

    <div class="cp-article-list-view-container">
      <div class="cp-article-list-view--horizontal-list">
        <div class="cp-article-list-view-horizontal-list-container">
          <!-- <ArticleBorderless
            v-for="(article, index) in suggestedArticles"
            :key="index"
            :image="article.cover_image"
            :title="article.title_localized"
            :excerpt="article.prefix_localized"
            @click="gotoArticlePage(article.id)"
          /> -->
        </div>
      </div>

      <hr class="has-background-primary" />

      <div class="cp-article-list-view-vertical-list columns is-multiline is-mobile is-centered">
        <div
          class="cp-article-list-view-vertical-item column is-12-mobile is-6-tablet is-4-desktop"
          v-for="(article, index) in articles"
          :key="index"
        >
          <!-- <Article
            class="cp-article-list-view-vertical-article"
            :title="article.title_localized"
            :excerpt="article.prefix_localized"
            :image="article.cover_image"
            @click="gotoArticlePage(article.id)"
          /> -->
          <ArticleBorderless
            :image="article.cover_image"
            :title="article.title_localized"
            :excerpt="article.prefix_localized"
            @click="gotoArticlePage(article.id)"
          />
        </div>
      </div>
      <b-button
        v-if="hasMoreData"
        class="cp-article-list-view-load-more"
        type="is-default"
        @click="loadMore"
        :loading="loading"
        >{{ $t('articles.loadmore.button') }}</b-button
      >
    </div>
    <OrderFloatIcon />
  </div>
</template>

<script>
// import Article from '@/components/Article.vue';
import ArticleBorderless from '@/components/ArticleBorderless.vue';
// import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';
import { getArticles, getSuggestedArticles } from '@/apis/article';
import OrderFloatIcon from '@/components/OrderFloatIcon.vue';

export default {
  name: 'ArticleView',
  components: {
    // Article,
    ArticleBorderless,
    OrderFloatIcon,
    // Breadcrumbs,
  },
  data() {
    return {
      articles: [],
      suggestedArticles: [],
      currPage: 1,
      pageSize: 5,
      loading: false,
      hasMoreData: true,
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      const loading = this.$buefy.loading.open();

      try {
        const { articles, total } = await getArticles(this.currPage, this.pageSize);
        this.articles = articles;
        this.suggestedArticles = await getSuggestedArticles(3);

        if (this.articles.length >= total) {
          this.hasMoreData = false;
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } finally {
        loading.close();
      }
    },
    async loadMore() {
      this.loading = true;

      try {
        const { articles, total } = await getArticles(this.currPage + 1, this.pageSize);
        this.articles = [...this.articles, ...articles];

        if (articles.length > 0) {
          this.currPage += 1;
        }
        if (this.articles.length >= total) {
          this.hasMoreData = false;
        }
      } finally {
        this.loading = false;
      }
    },
    gotoArticlePage(id) {
      this.$router.push({
        name: 'ArticleDetail',
        params: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.cp-article-list-view {
  &-header-image {
    position: relative;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 50vw;
  }

  &-breadcrumbs-container {
    border-top: 1px solid $primary;
    border-bottom: 1px solid $primary;
  }

  &-container {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }

  &-horizontal-list {
    padding-left: 20px;
    margin-bottom: 1.5rem;
    position: relative;
    width: 100%;
    height: 380px;
  }

  &-horizontal-list-container {
    margin-left: auto;
    margin-right: auto;
    width: max-content;
  }

  &-vertical-list {
    max-width: 1200px;
    margin-bottom: 20px;
    margin-left: auto;
    margin-right: auto;
  }

  &-vertical-article {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  &-vertical-item:first-child {
    margin-left: auto;
  }

  &-vertical-item:last-child {
    margin-right: auto;
  }

  &-item {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  &-load-more {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
  }
}
</style>
